import { render, staticRenderFns } from "./etusivu-virkailija.vue?vue&type=template&id=7da6fa50&"
import script from "./etusivu-virkailija.vue?vue&type=script&lang=ts&"
export * from "./etusivu-virkailija.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports